export default __webpack_public_path__ + "static/media/ulje.3c27abc7.jpg";